export const BYCE_CATEGORICAL_OPTIONS = [
  { value: 0, label: "Normal" },
  { value: 1, label: "Mild" },
  { value: 2, label: "Moderate" },
  { value: 3, label: "Severe" },
];

export const BYCE_CONSTRUCT_PRESENTATIONS = {
  "global-voice-severity": {
    label: "Global voice severity",
    instruction: "Rate the overall severity of the voice.",
    categorical: { sourceParameterLabel: "Grade", responseFamilyLabel: "categorical 0–3 rating", loaderKey: "overallSeverity" },
    continuous: { sourceParameterLabel: "Overall Severity", responseFamilyLabel: "continuous VAS rating" },
    anchors: { normal: "Normal reference", marked: "Severe reference", intermediate: "Intermediate reference" },
  },
  roughness: {
    label: "Roughness",
    instruction: "Rate the degree of perceived roughness.",
    categorical: { sourceParameterLabel: "Roughness", responseFamilyLabel: "categorical 0–3 rating", loaderKey: "roughness" },
    continuous: { sourceParameterLabel: "Roughness", responseFamilyLabel: "continuous VAS rating" },
    anchors: { normal: "Normal reference", marked: "Clear roughness reference", intermediate: "Intermediate roughness reference" },
  },
  breathiness: {
    label: "Breathiness",
    instruction: "Rate the degree of perceived breathiness.",
    categorical: { sourceParameterLabel: "Breathiness", responseFamilyLabel: "categorical 0–3 rating", loaderKey: "breathiness" },
    continuous: { sourceParameterLabel: "Breathiness", responseFamilyLabel: "continuous VAS rating" },
    anchors: { normal: "Normal reference", marked: "Clear breathiness reference", intermediate: "Intermediate breathiness reference" },
  },
  strain: {
    label: "Strain",
    instruction: "Rate the degree of perceived strain.",
    categorical: { sourceParameterLabel: "Strain", responseFamilyLabel: "categorical 0–3 rating", loaderKey: "strain" },
    continuous: { sourceParameterLabel: "Strain", responseFamilyLabel: "continuous VAS rating" },
    anchors: { normal: "Normal reference", marked: "Clear strain reference", intermediate: "Intermediate strain reference" },
  },
};

export function getBYCEConstructPresentation(constructId) {
  return BYCE_CONSTRUCT_PRESENTATIONS[constructId] || {
    label: constructId,
    instruction: `Rate the perceived ${constructId}.`,
  };
}

export function getBYCEAnchorDisplayLabel(anchor) {
  return anchor.labelKey || BYCE_CONSTRUCT_PRESENTATIONS[anchor.constructId]?.anchors?.[anchor.role];
}

const GOVERNED_RATER_PANEL_CONTRACT = "pvqd-governed-rater-panel-projection@1";

export function selectBYCEVoiceAssessmentReference(reference, sourceParameterId) {
  if (!reference || !sourceParameterId) return undefined;
  if (reference.contractVersion === GOVERNED_RATER_PANEL_CONTRACT) {
    return reference[sourceParameterId];
  }
  if (reference.voiceAssessmentFeedback &&
      typeof reference.voiceAssessmentFeedback === "object" &&
      !Array.isArray(reference.voiceAssessmentFeedback)) {
    return reference.voiceAssessmentFeedback[sourceParameterId];
  }
  return undefined;
}

export function adaptBYCECategoricalReference({ constructId, learnerValue, reference }) {
  const presentation = getBYCEConstructPresentation(constructId);
  return {
    constructLabel: presentation.label,
    sourceParameterLabel: presentation.categorical?.sourceParameterLabel,
    sourceLabel: "PVQD expert ratings",
    learnerValue: Number(learnerValue),
    reference: reference?.[presentation.categorical?.loaderKey],
  };
}

export function adaptBYCEContinuousReferenceRows({ constructs = [], pairedState, reference }) {
  return constructs.map(construct => {
    const presentation = getBYCEConstructPresentation(construct.id);
    return {
      constructLabel: presentation.label,
      sourceParameterLabel: presentation.continuous?.sourceParameterLabel || construct.continuous?.parameterId,
      learnerValue: pairedState?.constructs?.find(entry => entry.constructId === construct.id)?.continuous?.value,
      reference: reference?.[construct.continuous?.parameterId],
    };
  });
}

export function adaptBYCEPairedCategoricalReferenceRows({ constructs = [], pairedState, reference }) {
  return constructs.map(construct => {
    const presentation = getBYCEConstructPresentation(construct.id);
    return {
      constructId: construct.id,
      constructLabel: presentation.label,
      sourceParameterLabel: presentation.categorical?.sourceParameterLabel || construct.categorical?.parameterId,
      sourceLabel: "PVQD expert ratings",
      learnerValue: pairedState?.constructs?.find(entry => entry.constructId === construct.id)?.categorical?.value,
      reference: reference?.[presentation.categorical?.loaderKey],
    };
  }).filter(row => row.reference);
}
